import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin } from 'antd'
import { Column } from '@antv/g2plot';
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'

const data = [];


for(let i=0; i<12; i++) {
  data.push({
    "label": i+ 1 + "月",
    "type": "本年",
    "value": Math.floor(Math.random()*100)
  })
  data.push({
    "label": i+ 1 + "月",
    "type": "上年",
    "value": Math.floor(Math.random()*100)
  })
}

const tabsOptions = [
  {
    label: '按公司', 
    value: 'ags',
    api: null
  }, 
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

type BarItem = {
  label: string
  value: string
}

type PropType = FC<PropsWithChildren<{
  label1?: string
  value1?: string
  label2?: string
  value2?: string
  barLabel1: string
  barData1: BarItem[]
  barLabel2: string
  barData2: BarItem[]
  barLabel3?: string
  barData3?: BarItem[]
  notPrimary?: boolean
  totalItems?: {label: string, value: string, primary?: boolean} []
}>>

const Component: PropType = ({ label1, value1, label2, value2, barData1, barLabel1, barData2, barLabel2, barData3, barLabel3, notPrimary, totalItems }) => {
  const containerRef = useRef()
  const globalRef = useRef({
    params: {
      tab: '',
      depart: ''
    },
    column: null as Column,
  })

  const renderChart = useCallback(() => {
    if(!globalRef.current.column) {
      return
    }
    let data = [...barData1.map(r => ({
      ...r,
      type: barLabel1
    })), ...barData2.map(r => ({
      ...r,
      type: barLabel2
    }))]
    if(barData3 && barLabel3) {
      data = [...data, ...barData3.map(r => ({
        ...r,
        type: barLabel3
      }))]
    }
    globalRef.current.column.changeData(data)
  }, [barData1, barData2, barLabel1, barLabel2, barData3, barLabel3])

  useEffect(() => {
    globalRef.current.column = new Column(containerRef.current, {
      data: [],
      xField: 'label',
      yField: 'value',
      seriesField: 'type',
      isGroup: true,
      legend: {
        position: 'bottom',
      },
      columnStyle: {
      },
      yAxis: {
        label: {
          formatter: (text) => {
            return text + '万'
          }
        }
      }
    });

    globalRef.current.column.render();
    renderChart()
  }, [])

  useEffect(() => {
    renderChart()
  }, [renderChart])

  return (
    <div className='h-full pt-30 flex'>
      <div className='mr-20 flex flex-column space-around pt-0 pb-20'>
        {
          totalItems ? (
            totalItems.map(r => (
              <div key={r.label}>
                <div className='text-999'>{r.label}</div>
                <div className={`font-26 ${r.primary ? 'text-primary' : ''}`}>{r.value}</div>
              </div>
            ))
          ) : (
            <>
              <div>
                <div className='text-999'>{label1}</div>
                <div className={`font-26 ${notPrimary ? '' : 'text-primary'}`}>{value1}</div>
              </div>
              <div>
                <div className='text-999'>{label2}</div>
                <div className='font-26'>{value2}</div>
              </div>
            </>
          )
        }
      </div>
      <div className='flex-1 w-0 h-full'>
        <div className='h-full' ref={containerRef}></div>
      </div>
    </div>
  )
}

export default Component
